import { HighestCampaignsSection } from './highestCampaigns';
import { PercentageInsightPanel } from './PercentageInsightPanel';
import { useTranslation } from '../../../hooks';
import { useBehaviorQueryContext } from '../../../contexts/behaviorInsights/behaviorQuery';
import { useConversionInsightsContext } from '../../../contexts/behaviorInsights/conversionInsights';

export const ConversionRatePanel = () => {
  const { conversionRate } = useBehaviorQueryContext();
  const { isLoading, highestConvertingCampaigns = [] } = useConversionInsightsContext();
  const conversionMetric = conversionRate?.value;

  const { t } = useTranslation();
  return (
    <PercentageInsightPanel
      title={t('insights.conversionRate')}
      percentage={conversionMetric}
      showSelect
      isLoading={isLoading}
      isEmpty={highestConvertingCampaigns.length === 0}
    >
      {Number.isFinite(conversionMetric) && <HighestCampaignsSection />}
    </PercentageInsightPanel>
  );
};
